module.exports = __webpack_public_path__ + "static/media/cupertron.50a0e83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/xanthomonas_tomate/preventiva/cupertron.png
// module id = 2406
// module chunks = 3